import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import FormBlock from "../../../Components/Inputs/FormBlock";
import instance from "../../../Interceptor/api_instance";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";

const EditEmployee = ({ employee, close, onSuccess }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    firstName: employee.first_name,
    lastName: employee.last_name,
    title: employee.job_title,
  });

  const { mutate, isLoading, error } = useApiMutation(async (e) => {
    e.preventDefault();
    const response = await instance.patch(`/api/employees/${employee.id}/`, {
      first_name: formData.firstName,
      last_name: formData.lastName,
      job_title: formData.title,
    });
    if (response.status === 200) {
      onSuccess(response.data);
      close();
    }
  });

  return (
    <div className="page-mask page-mask-animation">
      <div className="white-cont">
        <h2>{t("Edit")}</h2>
        <form onSubmit={mutate}>
          <FormBlock
            label={t("yard-tables.table-columns.name")}
            value={formData.firstName}
            update={(e) =>
              setFormData({ ...formData, firstName: e.target.value })
            }
            isRequired={true}
          />
          <FormBlock
            label={t("forms.type.newDriver.input-headers.lastName")}
            value={formData.lastName}
            update={(e) =>
              setFormData({ ...formData, lastName: e.target.value })
            }
            isRequired={true}
          />
          <div className="form-block">
            <label className="input-label required">
              {t("yard-tables.table-columns.title")}
            </label>
            <div className="input-cont">
              <select
                className="text-input"
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
              >
                <option value="Guard">
                  {t("yard-tables.table-columns.guard")}
                </option>
                <option value="Mechanic">
                  {t("yard-tables.table-columns.mechanic")}
                </option>
              </select>
            </div>
          </div>
          {error && <p className="error">{error}</p>}
          <div className="full-cont">
            {isLoading ? (
              <Spinner />
            ) : (
              <button type="submit" className="change-pwd-btn">
                {t("buttons.save")}
              </button>
            )}
            <button className="cancel-btn" onClick={close}>
              {t("buttons.cancel")}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployee;
